import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { ImProfile } from "react-icons/im";
import { RiUserSettingsFill } from "react-icons/ri";
import { CiEdit } from "react-icons/ci";
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { getNames } from 'country-list';
import axios from 'axios';
import './account-settings.css';

function Settings() {
  const navigate = useNavigate();

  const countries = getNames().map(country => ({
    label: country,
    value: country,
  }));

  const pakistaniCities = [
    { label: 'Karachi', value: 'Karachi' },
    { label: 'Lahore', value: 'Lahore' },
    { label: 'Islamabad', value: 'Islamabad' },
    { label: 'Peshawar', value: 'Peshawar' },
    { label: 'Quetta', value: 'Quetta' },
    { label: 'Faisalabad', value: 'Faisalabad' },
    { label: 'Rawalpindi', value: 'Rawalpindi' },
    { label: 'Sialkot', value: 'Sialkot' },
  ];

  const [selectedCountry, setSelectedCountry] = useState({ label: 'Pakistan', value: 'Pakistan' });
  const [selectedCity, setSelectedCity] = useState(pakistaniCities[0]);
  const [user, setUser] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
    country: 'Pakistan',
    city: 'Karachi'
  });

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertType, setAlertType] = useState('success'); // NEW: reliable success/error styling
  const [saving, setSaving] = useState(false);           // NEW: submit feedback
  const userId = localStorage.getItem('userId');

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get(`https://backend.ems.uk.hiradentallab.com/api/user/user/${userId}`);
        const fetchedUser = response.data;
        setUser({
          name: fetchedUser.name || '',
          email: fetchedUser.email || '',
          phone: fetchedUser.phone || '',
          address: fetchedUser.address || '',
          country: fetchedUser.country || 'Pakistan',
          city: fetchedUser.city || 'Karachi',
        });
        setSelectedCountry({ label: fetchedUser.country || 'Pakistan', value: fetchedUser.country || 'Pakistan' });
        setSelectedCity({ label: fetchedUser.city || 'Karachi', value: fetchedUser.city || 'Karachi' });
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchUserData();
  }, [userId]);

  const handleResetPasswordClick = () => {
    navigate('/reset-password');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const updatedUser = {
        ...user,
        country: selectedCountry.value,
        city: selectedCity.value
      };

      const response = await axios.put(`https://backend.ems.uk.hiradentallab.com/api/user/update/${userId}`, updatedUser);

      if (response.status === 200) {
        setAlertType('success');
        setAlertMessage('User data updated successfully!');
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
          navigate('/profile');
        }, 3000);
      }
    } catch (error) {
      console.error('Error updating user data:', error);
      setAlertType('error');
      setAlertMessage('Error updating data. Please try again.');
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 3000);
    } finally {
      setSaving(false);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setUser((prevUser) => ({ ...prevUser, [name]: value }));
  };

  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption);
  };

  const handleCityChange = (selectedOption) => {
    setSelectedCity(selectedOption);
  };

  return (
    <div className='container-fluid settings-page-wrapper'>
      <div className='container-settings'>

        {/* Header Section */}
        <div className="settings-header">
          <h1 className="settings-title">
            <ImProfile className="settings-icon" /> Profile
          </h1>
          <hr className="settings-divider" />
          <h2 className="settings-subtitle">
            <RiUserSettingsFill className="settings-icon" /> Account Settings
          </h2>
        </div>

        {/* Alert Message */}
        {showAlert && (
          <div className={`custom-alert alert-${alertType}`} role="alert" aria-live="polite">
            {alertMessage}
          </div>
        )}

        {/* Form Section */}
        <div className="settings-container-inner">
          <Form onSubmit={handleSubmit} className="settings-form">
            <Row className="mb-4">
              <Form.Group as={Col} xs={12} md={6} controlId="formGridName">
                <Form.Label>Name</Form.Label>
                <Form.Control type="text" name="name" value={user.name || ''} onChange={handleChange} required placeholder="Enter Your Name" />
              </Form.Group>

              <Form.Group as={Col} xs={12} md={6} controlId="formGridEmail">
                <Form.Label>E-mail</Form.Label>
                <Form.Control type="email" name="email" value={user.email || ''} onChange={handleChange} required placeholder="Enter Your email" />
              </Form.Group>
            </Row>

            <Row className="mb-4">
              <Form.Group as={Col} xs={12} md={6} controlId="formGridPhone">
                <Form.Label>Phone</Form.Label>
                <Form.Control type="tel" name="phone" value={user.phone || ''} onChange={handleChange} required placeholder="Enter Your phone no." />
              </Form.Group>

              <Form.Group as={Col} xs={12} md={6} controlId="formGridCountry">
                <Form.Label>Country</Form.Label>
                <Select
                  inputId="formGridCountry"
                  name="country"
                  options={countries}
                  value={selectedCountry}
                  onChange={handleCountryChange}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select country"
                  required
                />
              </Form.Group>
            </Row>

            <Row className="mb-4">
              <Form.Group as={Col} xs={12} md={6} controlId="formGridCity">
                <Form.Label>City</Form.Label>
                <Select
                  inputId="formGridCity"
                  name="city"
                  options={pakistaniCities}
                  value={selectedCity}
                  onChange={handleCityChange}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select city"
                  required
                />
              </Form.Group>

              <Form.Group as={Col} xs={12} md={6} controlId="formGridAddress">
                <Form.Label>Address</Form.Label>
                <Form.Control type="text" name="address" value={user.address || ''} onChange={handleChange} required placeholder="Enter Your Address" />
              </Form.Group>
            </Row>

            {/* Actions */}
            <div className="settings-actions">
              <Button variant="outline-primary" onClick={handleResetPasswordClick} className="settings-btn-outline">
                Reset Password
              </Button>
              <Button variant="primary" type="submit" className="settings-btn-save" disabled={saving}>
                <CiEdit size={18} /> {saving ? 'Saving…' : 'Save Changes'}
              </Button>
            </div>
          </Form>
        </div>

      </div>
    </div>
  );
}

export default Settings;